/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedForceSearchLink_itemSearch$ref = any;
export type SbSharedForceSearchLink_itemSearch = {
    readonly semanticSearch: {
        readonly originalSearchTerm: string | null;
        readonly forceSearchUri: string | null;
    } | null;
    readonly " $refType": SbSharedForceSearchLink_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedForceSearchLink_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "semanticSearch",
            "storageKey": null,
            "args": null,
            "concreteType": "SemanticSearchType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "originalSearchTerm",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "forceSearchUri",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ace43480e8362a45815a881326ec0fd0';
export default node;
